module.exports = __webpack_public_path__ + "img/czleader3.aaf396f7.png";